<template>
  <v-card class="rounded-lg">
    <v-data-table
      :headers="headers"
      :items="platforms"
      sort-by="position"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Platforms list</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Platform</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Platform name"
                        filled
                        v-validate="{
                          required: true
                        }"
                        name="name"
                        :error-messages="errors.collect('name')"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          {{ mdiPencil }}
        </v-icon>
      </template>
    </v-data-table>
    <delete-dialog
      v-if="deleteDialog"
      :item="deletedItem"
      @close="deleteDialog = false"
      @confirm="deleteItem"
    />
  </v-card>
</template>

<script>
import { mdiPencil } from "@mdi/js"
export default {
  components: {
    deleteDialog: () => import('@/components/dialogs/DeleteDialog.vue'),
  },
  data: () => ({
    mdiPencil,
    dialog: false,
    deleteDialog: false,
    headers: [
      {
        text: 'Name',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'action',
        sortable: false,
      },
    ],
    platforms: [],
    editedIndex: -1,
    editedItem: {
      name: ''
    },
    defaultItem: {
      name: ''
    },
    deletedItem: null
  }),
  created() {
    this.$axios.get('/api/global/platforms')
    .then(payload => {
      this.platforms = payload.data;
    })
    .catch(err => {
      console.log(err)
    })
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Platfrom' : 'Edit Platfrom';
    },
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.platforms.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      try {
        let { data } = await this.$axios.delete('/api/global/platforms/' + item.id);
        this.platforms = data.sort((a,b) => a.position - b.position);
      } catch (err) {
        console.log(err.message);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save() {
      this.$validator.validateAll().then(async res => {
        if (res) {
          try {
            if (this.editedIndex > -1) {
              let { data } = await this.$axios.put('/api/global/platforms/' + this.editedItem.id, this.editedItem);
              this.$set(this.platforms, this.editedIndex, data);
            } else {
              let { data } = await this.$axios.post('/api/global/platforms/', this.editedItem);
              this.platforms.push(data);
            }
          } catch(err) {
            console.log(err.message);
          }
          this.close();
        }
      })
    },
  },
}
</script>
